export const STANDARD = 'qvh24inlineqv';
export const ADDTOCART = 'addToCart_qvh24';



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/constants/events.js
 **/